import { useEffect } from 'react';
import { useUserContext } from '../UserContext';

/**
 * Hook to show an alert when the user has pending changes
 * @param [Boolean] - hasUserPendingChanges - Indicates if the user has pending changes
 */
export const usePendingChangesAlert = (hasUserPendingChanges: boolean) => {
  const { userHasPendingChanges, setUserHasPendingChanges } = useUserContext();

  useEffect(() => {
    setUserHasPendingChanges(hasUserPendingChanges);
    return () => {
      setUserHasPendingChanges(false);
    };
  }, [hasUserPendingChanges, setUserHasPendingChanges]);

  return {
    userHasPendingChanges,
    setUserHasPendingChanges,
  };
};

export default usePendingChangesAlert;
